import { ReactComponent as Icon } from "../files/send-icon.svg";
import ISVGIconProps from "../ISVGIconProps";

const SendIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon fill={fill} style={style} />;
};

export default SendIcon;
